
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __appWithI18n from 'next-translate/appWithI18n'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";

import { Head } from "@/components/Head";
import { CTASection } from "@/sections/CTASection";
import { InspectorFeaturesSection } from "@/sections/InspectorFeaturesSection";
import { InspectorTopSection } from "@/sections/InspectorTopSection";
import { InspectorContactSection } from "@/sections/InspectorContactSection";
import { InspectorColumnedSection } from "@/sections/InspectorColumnedSection";
import { useTheme } from "@/hooks/useTheme";

const Inspector = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/Inspector"
        ogImage="/images/magicul-x-og-image.jpg"
      />

      <InspectorTopSection
        title={t("page/Inspector:title")}
        subtitle={t("page/Inspector:subtitle")}
        description={t("page/Inspector:description")}
        image={{
          src: "/images/inspector-preview.webp",
          alt: "Inspector preview",
        }}
        buttonLabel={t("page/Inspector:section/top.buttonLabel")}
        buttonHref="#inspector-contact-form"
        wrapperStyle={{ backgroundColor: colors.WHITE }}
      />

      <InspectorFeaturesSection
        title={t("page/Inspector:section/features.title")}
        description={t("page/Inspector:section/features.description")}
        items={[
          {
            title: t("page/Inspector:section/features.items.export.title"),
            description: t(
              "page/Inspector:section/features.items.export.description",
            ),
            image: {
              src: "/images/inspector-feature-1.png",
              alt: t("page/Inspector:section/features.items.export.title"),
            },
            imageWrapperStyle: {
              backgroundColor: "#FFF9EF",
              backgroundImage: "url('/images/inspector-feature-1-bg.svg')",
            },
          },
          {
            title: t("page/Inspector:section/features.items.handoff.title"),
            description: t(
              "page/Inspector:section/features.items.handoff.description",
            ),
            image: {
              src: "/images/inspector-feature-2.png",
              alt: t("page/Inspector:section/features.items.handoff.title"),
            },
            imageWrapperStyle: {
              backgroundColor: "#FFEEEF",
              backgroundImage: "url('/images/inspector-feature-2-bg.svg')",
            },
          },
          {
            title: t("page/Inspector:section/features.items.open.title"),
            description: t(
              "page/Inspector:section/features.items.open.description",
            ),
            image: {
              src: "/images/inspector-feature-3.png",
              alt: t("page/Inspector:section/features.items.open.title"),
            },
            imageWrapperStyle: {
              backgroundColor: "#EAE2FF",
              backgroundImage: "url('/images/inspector-feature-3-bg.svg')",
            },
          },
        ]}
      />

      <CTASection
        title={t("page/Inspector:section/cta.title")}
        href="#inspector-contact-form"
        wrapperBgColor={colors.GHOST_WHITE}
        buttonLabel={t("page/Inspector:section/cta.buttonLabel")}
        buttonStyle={{ padding: "10px 24px" }}
      />

      <InspectorColumnedSection
        title={t("page/Inspector:section/steps.title")}
        description={t("page/Inspector:section/steps.description")}
        items={[
          {
            images: [
              {
                src: "/images/inspector-workflow-feature-1.png",
                alt: t("page/Inspector:section/steps.items.view.imageAlt"),
                wrapperStyle: {
                  position: "relative",
                  width: "100%",
                  borderRadius: 8,
                  overflow: "hidden",
                },
                customStyle: { width: "100%" },
              },
            ],
            imageBgStyle: {
              position: "absolute",
              width: 438,
              height: 438,
              backgroundColor: "#6D3CEA",
              opacity: 0.25,
              filter: "blur(220px)",
              top: -42,
              right: -111,
              borderRadius: 9999,
            },
            title: t("page/Inspector:section/steps.items.view.title"),
            description: t(
              "page/Inspector:section/steps.items.view.description",
            ),
            rightSidedImage: true,
            button: {
              label: t("page/Inspector:section/steps.items.view.buttonLabel"),
              href: "#inspector-contact-form",
            },
          },
          {
            images: [
              {
                src: "/images/inspector-workflow-feature-2.png",
                alt: t("page/Inspector:section/steps.items.inspect.imageAlt"),
                wrapperStyle: {
                  position: "relative",
                  width: "100%",
                  borderRadius: 8,
                  overflow: "hidden",
                },
                customStyle: { width: "100%" },
              },
              {
                src: "/images/inspector-workflow-feature-2-popup.png",
                alt: t(
                  "page/Inspector:section/steps.items.inspect.popUpImageAlt",
                ),
                wrapperStyle: {
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  width: "41%",
                },
                customStyle: {
                  filter:
                    "drop-shadow(0px -4px 27px rgba(16, 5, 48, 0.18)) drop-shadow(0px 4px 11px rgba(16, 5, 48, 0.18))",
                  width: "100%",
                },
              },
            ],
            imageBgStyle: {
              position: "absolute",
              width: 438,
              height: 438,
              backgroundColor: "#6179FF",
              opacity: 0.2,
              filter: "blur(220px)",
              top: -54,
              left: -111,
              borderRadius: 9999,
            },
            title: t("page/Inspector:section/steps.items.inspect.title"),
            description: t(
              "page/Inspector:section/steps.items.inspect.description",
            ),
            button: {
              label: t(
                "page/Inspector:section/steps.items.inspect.buttonLabel",
              ),
              href: "#inspector-contact-form",
            },
          },
          {
            images: [
              {
                src: "/images/inspector-workflow-feature-3.png",
                alt: t("page/Inspector:section/steps.items.share.imageAlt"),
                wrapperStyle: {
                  position: "relative",
                  width: "100%",
                  borderRadius: 8,
                  overflow: "hidden",
                },
                customStyle: { width: "100%" },
              },
              {
                src: "/images/inspector-workflow-feature-3-popup.png",
                alt: t(
                  "page/Inspector:section/steps.items.share.popUpImageAlt",
                ),
                wrapperStyle: {
                  position: "absolute",
                  left: 0,
                  bottom: 0,
                  width: "43%",
                },
                customStyle: {
                  filter: "drop-shadow(7px 12px 27px rgba(16, 5, 48, 0.18))",
                  width: "100%",
                },
              },
            ],
            imageBgStyle: {
              position: "absolute",
              width: 438,
              height: 438,
              backgroundColor: "#7427EF",
              opacity: 0.2,
              filter: "blur(220px)",
              top: -54,
              right: -111,
              borderRadius: 9999,
            },
            title: t("page/Inspector:section/steps.items.share.title"),
            description: t(
              "page/Inspector:section/steps.items.share.description",
            ),
            rightSidedImage: true,
            button: {
              label: t("page/Inspector:section/steps.items.share.buttonLabel"),
              href: "#inspector-contact-form",
            },
          },
        ]}
      />

      <InspectorContactSection
        title={t("page/Inspector:section/contact.title")}
        description={t("page/Inspector:section/contact.description")}
      />
    </>
  );
};

const __Page_Next_Translate__ = Inspector;


// @ts-ignore
    export default __appWithI18n(__Page_Next_Translate__, {
// @ts-ignore
      ...__i18nConfig,
// @ts-ignore
      isLoader: true,
// @ts-ignore
      skipInitialProps: false,
// @ts-ignore
      
// @ts-ignore
    });
// @ts-ignore
  